__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "crew-calendar";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@apollo/client", "3.13.8", () => (Promise.all([__webpack_require__.e(516), __webpack_require__.e(320), __webpack_require__.e(276), __webpack_require__.e(527), __webpack_require__.e(509)]).then(() => (() => (__webpack_require__(4276))))));
			register("antd", "5.14.2", () => (Promise.all([__webpack_require__.e(917), __webpack_require__.e(85), __webpack_require__.e(527), __webpack_require__.e(929)]).then(() => (() => (__webpack_require__(8085))))));
			register("apollo-upload-client", "17.0.0", () => (Promise.all([__webpack_require__.e(516), __webpack_require__.e(320), __webpack_require__.e(509), __webpack_require__.e(715)]).then(() => (() => (__webpack_require__(3715))))));
			register("apollo3-cache-persist", "0.15.0", () => (__webpack_require__.e(223).then(() => (() => (__webpack_require__(1604))))));
			register("graphql", "16.11.0", () => (__webpack_require__.e(366).then(() => (() => (__webpack_require__(5366))))));
			register("moment", "2.30.1", () => (__webpack_require__.e(178).then(() => (() => (__webpack_require__(6178))))));
			register("react-big-calendar", "1.14.1", () => (Promise.all([__webpack_require__.e(550), __webpack_require__.e(527), __webpack_require__.e(929), __webpack_require__.e(621)]).then(() => (() => (__webpack_require__(5550))))));
			register("react-device-detect", "2.2.3", () => (Promise.all([__webpack_require__.e(738), __webpack_require__.e(527)]).then(() => (() => (__webpack_require__(8738))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(527)]).then(() => (() => (__webpack_require__(7950))))));
			register("react", "18.2.0", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(5043))))));
			register("web-vitals", "2.1.4", () => (__webpack_require__.e(453).then(() => (() => (__webpack_require__(6453))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};